import { render, staticRenderFns } from "./DragDropMultipleList.vue?vue&type=template&id=0a42ff60&"
import script from "./DragDropMultipleList.vue?vue&type=script&lang=js&"
export * from "./DragDropMultipleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports